<template>
    <div v-if="sections.length" class="hidden-xs">
        <div v-for="section in sections" :key="section._id">
            <div v-if="['current', 'directReport', 'manager'].includes(section)">
                <div v-for="teamMember in items[section]" :key="teamMember._id" class="tw-mb-2">
                    <div
                        class="tw-flex tw-items-center tw-justify-center sidebar-menu mouseover-parent"
                        :class="{ 'sidebar-menu-active': isHighlighted(teamMember._id) }"
                    >
                        <div
                            class="clickable tw-flex-none"
                            tabindex="0"
                            @click="visitProfile({ userId: teamMember._id })"
                            @keyup.enter="visitProfile({ userId: teamMember._id })"
                        >
                            <l-profile-picture :user="teamMember" size="s" />
                        </div>

                        <div
                            data-test-class="colleague"
                            class="clickable tw-ml-4 tw-flex-grow tw-min-w-0 tw-truncate"
                            @click="visitProfile({ userId: teamMember._id })"
                            @keyup.enter="visitProfile({ userId: teamMember._id })"
                        >
                            {{ teamMember.firstname }} {{ teamMember.lastname }}
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="!!currentUser.rights.P_ORG && section == 'company'"
                class="tw-flex tw-items-center tw-justify-center sidebar-menu tw-mb-2"
            >
                <div
                    class="clickable tw-flex-grow tw-min-w-0 tw-truncate"
                    @click="showOrgchart()"
                    @keyup.enter="showOrgchart()"
                >
                    <i class="fal fa-users tw-mt-2 tw-mb-2 tw-ml-1"></i>
                    <span class="tw-ml-5">
                        {{ teamName }}
                    </span>
                </div>
            </div>

            <div
                v-if="
                    currentUser.teamRole &&
                        currentUser.teamRole.hasDirectReports &&
                        section == 'team' &&
                        (currentUser.rights.F_VIEW ||
                            currentUser.rights.R_VIEW ||
                            currentUser.rights.G_VIEW)
                "
                class="tw-flex tw-items-center tw-justify-center sidebar-menu tw-mb-2"
                :class="{ 'sidebar-menu-active': isHighlighted() }"
            >
                <div
                    class="clickable tw-flex-grow tw-min-w-0 tw-truncate"
                    @click="showTeamDashboard()"
                    @keyup.enter="showTeamDashboard()"
                >
                    <i class="fal fa-users tw-mt-2 tw-mb-2 tw-ml-1"></i>
                    <span class="tw-ml-5">
                        {{ $t(`teamDashboard.title`) }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LProfilePicture from "@/components/LProfilePicture";

export default {
    components: { LProfilePicture },
    props: {
        userId: {
            type: String,
            default: "",
        },
    },
    data() {
        return {};
    },
    computed: {
        ...mapGetters({
            userList: "users/list/list",
            currentUser: "users/current/user",
            teamSettings: "users/current/teamSettings",
        }),
        items() {
            const users = this.userList();
            let directReport = users.filter(
                user => user?.teamRole?.reportsTo?._id === this.currentUser._id,
            );
            let manager = users.filter(user => user._id === this.currentUser?.teamRole?.reportsTo);
            return { manager, current: [this.currentUser], team: {}, directReport, company: {} };
        },
        sections() {
            return Object.keys(this.items);
        },
        teamName() {
            return this.teamSettings?.name;
        },
    },
    created() {
        this.$store.dispatch({
            type: "users/list/get",
            payload: { userFilter: { include: { admin: [{ _id: "directTeam" }] } } },
        });
    },
    methods: {
        visitProfile({ userId }) {
            this.$router.push(`/profile/${userId}`);
        },
        isHighlighted(_id) {
            if (_id) {
                return this.userId === _id && this.$route?.name !== "TeamDashboard";
            } else {
                return this.$route?.name === "TeamDashboard";
            }
        },
        showOrgchart() {
            this.$router.push("/orgchart");
        },
        showTeamDashboard() {
            this.$router.push("/profile/" + this.currentUser._id + "/team");
        },
    },
};
</script>
